import React from 'react';
import ClientsEdit from "./ClientsEdit";
import ClientsManagementBarButtons from "./ClientsManagementBar";
import EntriesIterator from "../../components/EntriesIterator";
import {getActiveClients, getClients} from "../../services/ClientsService";
import {CONFIG_TABLE_MAX_X, PATH_WS} from "../../constants/constants";
import SockJsClient from 'react-stomp';
import {Icon, Table} from 'antd';

class Clients extends EntriesIterator {

    reloadPage = (client) => {
        this.onPage(this.state.page, this.state.filters);
        this.onClose();
    };

    onClose = () => {
        this.setState({key: new Date().getTime()});
    };

    processPaginatedRequest(page, rows, filters) {
        return getClients(page, rows, filters);
    }

    requestConnectionStatus() {
        getActiveClients()
            .then(response => {
                this.setState({
                    activeClients: response.content
                });
            });
    }

    renderAdditionalColumns() {
        return null;
    }

    getClientConnectionInfo(id) {
        if (this.state.activeClients) {
            const client = this.state.activeClients.find(c => c.user === id);
            const info = {
                icon: client ? "check-circle" : "warning",
                theme: client ? "twoTone" : "filled",
                version: client ? client.version : '?'
            };
            return info;
        } else {
            return {
                icon: "loading",
                theme: ""
            };
        }
    }

    renderView() {
        let columns = [{
            dataIndex: 'id',
            key: 'id',
            render: id => <Icon type={this.getClientConnectionInfo(id).icon}
                                theme={this.getClientConnectionInfo(id).theme}
                                className="big-icon"/>,
            width: '3em',
            align: 'center',
            fixed: 'left',
        }, {
            title: 'Versión',
            dataIndex: 'id',
            key: 'version',
            render: id => this.getClientConnectionInfo(id).version,
            width: '5em',
            align: 'center',
        }, {
            title: 'Nombre',
            render: client => {
                return client.group ? '(' + client.group + '#' + client.index + ') ' + client.name : client.name
            },
            key: 'name',
        }, {
            title: 'Dirección',
            dataIndex: 'address',
            key: 'address',
            render: (address, client) => <div>
                {
                    client.requestLocation ?
                        <span style={{marginRight: '5px'}}>
                            <Icon type='environment' theme='twoTone'/>
                        </span> : null
                }
                {address}
            </div>
        }, {
            title: 'Usuarios',
            dataIndex: 'users',
            key: 'users',
            align: 'center',
            width: '7em',
        }, {
            title: 'Accesos',
            dataIndex: 'recentAccesses',
            key: 'recentAccesses',
            align: 'center',
            width: '7em',
        }, {
            key: 'operations',
            render: (client) => <div>{
                <ClientsEdit
                    client={JSON.parse(JSON.stringify(client))}
                    currentUser={this.state.userData}
                    key={"editForm" + client.id} isAdmin={this.state.isAdmin}
                    onSave={this.reloadPage} onDelete={this.reloadPage}/>
            }</div>,
            width: '7em',
            fixed: 'right',
            align: 'center'
        }];

        const moreColumns = this.renderAdditionalColumns();
        if (moreColumns != null) {
            columns = columns.concat(moreColumns);
        }

        return <div>
            <SockJsClient url={PATH_WS} topics={['/clients']}
                          onMessage={(msg) => {
                              this.setState({
                                  activeClients: msg['data']['socketSessions']
                              });
                          }}
                          onConnect={() => {
                              this.requestConnectionStatus()
                          }}
                          onDisconnect={(number) => {
                              this.setState({
                                  activeClients: []
                              });
                          }}
                          ref={(client) => {
                          }}
                          headers={{"user": ["*"], "source": this.props.userData.id}}/>
            <div className="action-separator x3">
                <ClientsManagementBarButtons
                    client={{configuration: {}, enabled: true}}
                    currentUser={this.state.currentUser}
                    key={"add_" + this.state.key} isAdmin={this.state.isAdmin}
                    onSave={this.reloadPage} onDelete={this.reloadPage} onClose={this.onClose}/>

            </div>

            <Table dataSource={this.state.data} columns={columns} bordered loading={this.state.loading}
                   pagination={this.getPagination()} size="small" onChange={this.handleStateChange} rowKey="id"
                   rowClassName={(client, pos) => client.enabled ? '' : 'disabled'} scroll={{ x: CONFIG_TABLE_MAX_X }}/>
        </div>
    }
}

export default Clients;


// WEBPACK FOOTER //
// ./src/app/views/clients/Clients.js